; (function ($) {

    let heroSlideOptions = {
        infinite: true,
        prevArrow: '#hero-prev',
        nextArrow: '#hero-next',
        dots: true,
        // dotsClass: 'mobile-dots',
        customPaging : function(slider, i) {
            return '<a><img alt="custom naviatgation dots" src="/wp-content/themes/canarchy2.0/assets/images/hero-dot.svg" /><img alt="custom naviatgation dots" src="/wp-content/themes/canarchy2.0/assets/images/hero-dot-active.svg" /></a>';
        }
    }

    $(document).ready(function(){
        $('.hero-slide-container').slick(heroSlideOptions);

   $('h3.decorate.archive').toggle("slide", { direction: "left" }, 500);

    });


    $(window).load(function(){


    });

  })(jQuery);
